import React, { useEffect, useRef } from 'react';
import { Subject } from "rxjs";
import { FormPane } from "../../components/FormZero/PageComponents/FormPane/FormPane";
import { DataGridPro as DataGrid, DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import axios from "axios";
import { Button } from "../../components/FormZero/Button/Button";
import { Button as MUIButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ThemeProvider, createTheme, Paper, Stack } from '@mui/material';
import { ActionPanel } from "../../components/FormZero/ActionPanel/ActionPanel";
import * as XLSX from "xlsx";
import { TextField } from "@mui/material";
import SearchChips from '../../components/SearchChips';
import { ISearchChips } from '../../interfaces/Core/ISearchChips';
import ActionMenu from '../../components/ActionMenu';
import ActionButton from '../../components/ActionButton';
import { CustomDataGrid } from '../../components/StripedDataGrid'
import { IApplication } from '../../interfaces/IApplication';
import { useAppDispatch } from '../../hooks';
import { setPageTitle } from '../../slices/applicationSlice';
import moment from 'moment';
import { IDeliveryHeader } from '../../interfaces/Logistics/IDeliveryHeader';
import CheckIcon from '@mui/icons-material/FactCheck';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { ISeedDemand } from '../../interfaces/SeedDemands/ISeedDemand';


function PanelView(props: { dataSource: any; selectedRows: any; }) {
    const { dataSource, selectedRows } = props;

    const [showDownloadDialog, setShowDownloadDialog] = React.useState(false);
    const [showBulkVerifyDialog, setBulkVerifyDialog] = React.useState(false);

    async function downloadReport() {
        try {
            let r = [...dataSource].filter(r => r.is_ordered === 0).map(r => {
                let z = { ...r };
                delete z['id'];
                return z;
            });
            // let s = [header, ...r];

            const ws = XLSX.utils.json_to_sheet(r);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Export');

            XLSX.writeFile(wb, "SeedToBeOrdered.xls"); // <-- just do it this way.
            // TODO: submit to server the ones that have now been printed

            console.log(dataSource);

            let data = { items: dataSource.filter((r: { is_ordered: number; }) => r.is_ordered === 0).map((x: { id: any; }) => x.id), value: 1 };
            const resp = await axios.put(
                `/seeding/markOrdered`,
                data
            );
            console.log(resp);
        } catch (e: any) {
            console.log(e)
            alert(e.message);
        }
    }

    async function bulkMarkVerified() {
        console.warn("bulkMarkVerified not implemented");
        // return;

        try {
            // TODO: grab the ones that are selected and mark them as verified
            // let r = [...dataSource].filter(r => r.is_ordered === 1 && selectedRows.indexOf(r.id) > -1).map(r => {
            //     let z = {...r};
            //     delete z['id'];
            //     // r['truck'] = r['truck'].truck_number;
            //     return z;
            // });
            // let s = [header, ...r];

            let data = { items: dataSource.filter((r: { is_ordered: number; id: any; }) => r.is_ordered === 1 && selectedRows.indexOf(r.id) > -1).map((x: { id: any; }) => x.id), value: 2 };
            console.log(data);
            // return;
            const resp = await axios.put(
                `/seeding/markOrdered`,
                data
            );
            console.log(resp);
        } catch (e: any) {
            console.log(e)
            alert(e.message);
        }
    }

    return (
        <>
            <div className="SprayRecordsGrid_PanelView">
                {/*PanelContents*/}
                <div className="row">
                    <div className="col-6">
                        <Button fullWidth={true} className="button-square" clickHandler={() => setShowDownloadDialog(true)} text={"Download Seed To Order File"} />
                        {(showDownloadDialog) && (
                            <Dialog
                                open={true}
                                onClose={() => setShowDownloadDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                                    Download Seed To Order File
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Click Download to Download Seed To Order File
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => downloadReport()} autoFocus text={"Download"} fullWidth={true} />
                                    <Button onClick={() => setShowDownloadDialog(false)} autoFocus text={"Close"} fullWidth={true} />
                                </DialogActions>
                            </Dialog>
                        )}
                    </div>
                    <div className="col-6">
                        <Button fullWidth={true} className="button-square" clickHandler={() => setBulkVerifyDialog(true)} text={"Bulk Verify"} />
                        {(showBulkVerifyDialog) && (
                            <Dialog
                                open={true}
                                onClose={() => setBulkVerifyDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                                    Bulk Verify
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Click Here to Verify All Selected Seed Orders
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => bulkMarkVerified()} autoFocus text={"Verify"} fullWidth={true} />
                                    <Button onClick={() => setBulkVerifyDialog(false)} autoFocus text={"Close"} fullWidth={true} />
                                </DialogActions>
                            </Dialog>
                        )}
                    </div>
                </div>

            </div>
        </>
    )
}

function ChangeStatusDialog(props: { cellValues: any; isLoadingCompleted: any; updateUI: any; }) {
    const { cellValues, isLoadingCompleted, updateUI } = props;

    const [isOpen, setOpen] = React.useState(false);
    const onCellEditCommit = async (cellEdit: { id: any; field: any; value: any; }) => {
        console.log(cellEdit);
        let data = { field: cellEdit.field, value: cellEdit.value };
        const resp = await axios.put(
            `/seeding/status/${cellEdit.id}`,
            data
        );
        await updateUI();
        setOpen(false);
        console.log(resp);
    }

    const buttons = [
        {
            value: 0,
            label: "Canceled"
        },
        {
            value: 1,
            label: "Ordered & Unverified"
        },
        {
            value: 2,
            label: "Verified"
        },
    ];

    return (<>
        <MUIButton fullWidth={true} disabled={isLoadingCompleted} variant={'contained'} color={"secondary"} onClick={() => setOpen(true)}>Status: {cellValues.row.comment !== null ? cellValues.row.comment : "OK"}</MUIButton>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Update Status
            </DialogTitle>
            <DialogContent style={{ width: '500px', textAlign: 'center' }}>
                <DialogContentText id="alert-dialog-description">
                    {cellValues.row.species} - {cellValues.row.class} - {cellValues.row.variety}
                </DialogContentText>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                    {buttons.map((btn) => {
                        return (<MUIButton disabled={isLoadingCompleted} fullWidth={true} variant={'contained'} color={"secondary"} onClick={() => {
                            onCellEditCommit({
                                id: cellValues.id,
                                field: "is_ordered",
                                value: btn.value
                            }).then(() => {
                                setOpen(false)
                            })
                        }}>{btn.label}</MUIButton>);
                    })}
                </div>

            </DialogContent>
            <DialogActions>
                <MUIButton onClick={() => setOpen(false)}>Close</MUIButton>
            </DialogActions>
        </Dialog>
    </>)
}

export function SeedDemand(props: any) {

    const dispatch = useAppDispatch();

    useEffect(() => {

        let appState: IApplication = {
            pageTitle: "Seed Demand"
        }
        dispatch(setPageTitle(appState));
    }, []);
    const { } = props;


    const filterFormStructure = [
        { key: "week_year", type: "week-filter", size: { default: 4 }, label: "Week", required: true },
        { key: "week_year_view", type: "header", size: { default: 4 }, valueKey: "week_year" },
    ];
    const filterFormSubject = new Subject();
    const [formFilter, setFormFilter] = React.useState({});
    filterFormSubject.subscribe((n: any) => setFormFilter(n));

    // const columns = [
    //     {field: "id", headerName: "ID", width: 200},
    //     {field: "sow_week", headerName: "Sow Week", width: 200},
    //     {field: "ship_week", headerName: "Ship Week", width: 200},
    //     {field: "is_ordered", headerName: "Is Ordered", width: 200},
    //     {field: "description", headerName: "Description", width: 200},
    //     {field: "quantity", headerName: "Quantity", width: 200},
    //     {field: "quantity_to_order", headerName: "Quantity To Order", width: 200},
    //     {field: "notes", headerName: "Notes", width: 200},
    //     {field: "status_btn", headerName: " ", width: 200,
    //         renderCell: (cellValues) => {
    //             return (<ChangeStatusDialog cellValues={cellValues} isLoadingCompleted={false} updateUI={loadData} />);
    //         }
    //     },
    // ]

    function DetailPanelContent({ row: rowProp }: { row: ISeedDemand }) {
        let orderHeader = rowProp.seedDemandOrderHeader;
        let details = orderHeader?.seedDemandDetails!;
        return (
            <Stack
                sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
                direction="column"
            >
                <Paper sx={{ flex: 1, p: 1 }}>
                    <Stack direction="column" spacing={1} sx={{ height: 1 }}>
                        <DataGridPro
                            density="compact"
                            checkboxSelection={true}
                            columns={[
                                { field: "brokerLineItemNumber", headerName: "Broker Line Item", width: 150 },
                                { field: "brokerMaterialNumber", headerName: "Broker Material", width: 200 },
                                { field: "vendorMaterialNumber", headerName: "Vendor Material", width: 200 },
                                { field: "materialDescription", headerName: "Material Description", width: 300 },
                                { field: "orderedQTY", headerName: "Quantity", width: 75 },
                                { field: "unitPrice", headerName: "Unit Price", width: 200 },
                                { field: "scheduledShipDate", headerName: "Sch. Ship Date", width: 200 },
                                { field: "unitPrice1", headerName: "Patch Week", width: 200 },
                                { field: "unitPrice2", headerName: "Buffer", width: 200 },
                                { field: "unitPrice3", headerName: "Buffer Per Unit", width: 200 },
                                { field: "unitPrice4", headerName: "Trays", width: 200 },
                                { field: "unitPrice5", headerName: "To Order", width: 200 },
                                { field: "unitPrice6", headerName: "Ordered", width: 200 },
                                { field: "unitPrice7", headerName: "Seeds Per Cell", width: 200 },
                                { field: "unitPrice8", headerName: "Hold Week", width: 200 },
                                { field: "unitPrice9", headerName: "Patching Hold Week", width: 200 },
                                { field: "unitPrice99", headerName: "Sow Week", width: 200 },
                                { field: "unitPrice999", headerName: "Sow On", width: 200 },
                                { field: "unitPrice9999", headerName: "Ship Week", width: 200 },
                            ]}
                            rows={details}
                            sx={{ flex: 1 }}
                            hideFooter
                        />
                    </Stack>
                </Paper>
            </Stack>
        );
    }


    const columns: GridColDef[] = [
        // tray size,
        { field: "id", headerName: "ID", width: 100 },
        { field: "referenceId", headerName: "Reference Id", width: 315 },
        {
            field: "referenceDate", headerName: "Reference Date", align: 'center', width: 125, valueFormatter: params =>
                moment(params?.value).format("DD/MM/YYYY")
        },
        {
            field: "importedOn", headerName: "Imported On", width: 200, valueFormatter: params =>
                moment(params?.value).format("DD/MM/YYYY")
        },
        {
            field: "status_btn", headerName: " ", width: 200,
            renderCell: (cellValues: any) => {
                return (<ChangeStatusDialog cellValues={cellValues} isLoadingCompleted={false} updateUI={loadData} />);
            }
        },



    ]

    const [selectionModal, setSelectionModal] = React.useState([]);

    const [rows, setRows] = React.useState<any>([]);
    const [page, setPage] = React.useState(1);
    const loadData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/SeedDemands`);
            setRows(response.data);

            // TODO process this to merge them by seed species....
            console.table(response.data);

            // setRows(response.data.data);
            //               setCurrentPage(response.data.current_page);
            //                 setTotalPage(response.data.total);
        } catch (e) {
            console.error(e);
        }
    };
    React.useEffect(() => {
        loadData().then();
    }, [])

    const panel = (<PanelView dataSource={rows} selectedRows={selectionModal} />);

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }

    let actionMenuButtons = [
        <ActionButton action={() => onButtonClick()} buttonLabel='UPLOAD SEED DEMAND FILE'></ActionButton>
    ]

    const inputFile = useRef<HTMLInputElement | null>(null);

    const onButtonClick = () => {
        console.log("ON BUTTON CLICK");
        inputFile.current?.click();
        console.log(inputFile.current);
    }

    const handleFileSelected = (e: React.ChangeEvent<HTMLInputElement>): void => {
        console.log("Hello!");
        if (e.target.files != null) {
            const files = Array.from(e.target.files);
            const headers = {
                'Content-Type': 'multipart/form-data'
            }
            var bodyFormData = new FormData();
            bodyFormData.append('files', files[0]);
            axios.post(`${process.env.REACT_APP_ENDPOINT}/api/SeedDemands/demand-upload`, bodyFormData, {
                headers: headers
            }).then((data) => {
                console.log(data);
            });
        }
    }

    const getDetailPanelHeight = React.useCallback(() => 400, []);

    const getDetailPanelContent = React.useCallback<
        NonNullable<DataGridProProps['getDetailPanelContent']>
    >(({ row }) => <DetailPanelContent row={row} />, []);

    return (
        <>
            <input type='file' id='file' ref={inputFile} onChange={handleFileSelected} style={{ display: 'none' }} />
            <ActionMenu buttons={actionMenuButtons}></ActionMenu>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <ThemeProvider theme={darkTheme}>
                    <SearchChips handleSearch={handleSearchChips}></SearchChips>
                </ThemeProvider>
                <div style={{
                    flexGrow: 1
                }}>
                    <CustomDataGrid
                        sx={{ backgroundColor: 'white' }}
                        rows={rows}
                        columns={columns}
                        rowsPerPageOptions={[15]}
                        page={page}
                        pageSize={15}
                        onPageChange={((page: React.SetStateAction<number>, details: any) => {
                            setPage(page)
                        })}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        // onCellEditCommit={onCellEditCommit}
                        selectionModel={selectionModal}
                        getDetailPanelContent={getDetailPanelContent}
                        getDetailPanelHeight={getDetailPanelHeight}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                    // onSelectionModelChange={setSelectionModal} //Put this back - Corey
                    />
                </div>
            </div>
        </>);
}